import classes from "../classes.module.scss";
import type { ValidationError } from "class-validator";
import StepEmailHeader from "./StepEmailHeader";
import StepEmailPanelsInner from "./StepEmailPanelsInner";
import type { StepEmailSiteTexts } from "../hooks/useStepEmailSiteTexts";
import type { SsoOauthLoginPresetRow } from "./StepSsoOauthLoginPresetPicker";

type Props = {
	siteTexts: StepEmailSiteTexts;
	showSsoProfessionalBlock: boolean;
	showSsoOauthLoginPresetPicker: boolean;
	ssoOauthLoginPresets: readonly SsoOauthLoginPresetRow[];
	onSsoProfessionalClick: () => void;
	onSsoOauthLoginPresetEmail: (email: string) => void | Promise<void>;
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
	prefilledEmail: string;
};

export default function StepEmailPanelsContent(props: Props): React.JSX.Element {
	const { siteTexts, ...innerProps } = props;

	return (
		<div className={classes["root"]}>
			<StepEmailHeader welcomeTitle={siteTexts.welcomeTitleDisplay} welcomeSubtitle={siteTexts.welcomeSubtitleDisplay} />
			<StepEmailPanelsInner siteTexts={siteTexts} {...innerProps} />
		</div>
	);
}
